module.exports = __webpack_public_path__ + "img/jianjie.0e60d5f4.jpg";